'use strict';/* global define:false */define('helen/filters/sanitize',[],function(){'use strict';// var map = {
//   '&' :  '&amp;',
//   '<' :  '&lt;',
//   '>' :  '&gt;',
//   '"' :  '&quot;'
// };
// function mapper( match ) {
//   return map[ match ];
// }
function filter(){return function(string){return String(string||'')// .replace( /&|<|>|"/g, mapper );
// .replace( /&/g, '&amp;' ) // YOLO
.replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');};}return filter;});
